
ADILF.define('streamhub-sdk/content/views/mixins/card-content-view-mixin',['require','exports','module','streamhub-sdk/content/views/mixins/theme-mixin'],function (require, exports, module) {var hasTheme = require('streamhub-sdk/content/views/mixins/theme-mixin');

'use strict';

/**
 * A mixin that decorates an instance of ContentView 
 * to have default card theme
 */
function asCardContentView(contentView) {
    hasTheme(contentView, 'content-default');
};

module.exports = asCardContentView;

});
